<ng-progress #progressBar id="router-progressbar"></ng-progress>
<router-outlet></router-outlet>